export { OffersModule } from './OffersModule';
